import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Modal from 'react-modal'
import gameActions from '../../store/actions/gameActions'
import MatildeBalloon from '../MatildeBalloon'
import MyResponsivePie from '../charts/Pie'
import { Emoji } from '../ReactionIcons'
import Button from '../Button'

const NarrativeEndScreen = () => {
    const [state, setState] = useState({
        open: false,
        item: null
    })

    const dispatch = useDispatch()
    const gameState = useSelector(state => state.game)
    const { item, open } = state
    const { currentNarrativeObject, chapter, choicesMade, choicesMadeName, endingType, rewards, minigamesPlayed, narrativeChoices } = gameState
    const { items, exp } = rewards
    const { country } = currentNarrativeObject
    const chapterNumber = chapter.replace(/\D/g, "")

    const _getChoicePercentage = (choice) => {
        let totalChoices = 0
        let percentages = []

        console.log(choice)

        for (let item of choice) {
            totalChoices += item.number
        }

        for (let item of choice) {
            percentages.push({
                id: item.choice,
                label: item.choice,
                value: Math.round(item.number / totalChoices * 100),
                color: "hsl(21, 70%, 50%)"
            })
        }

        return percentages
    }

    const _getSimplePercentage = (choice, choiceMade) => {
        let totalChoices = 0
        for (let item of choice) {
            totalChoices += item.number
        }

        for (let item of choice) {
            if (item.choice === choiceMade) {
                return Math.round(item.number / totalChoices * 100)
            }
        }

    }

    const filterMinigamesPlayed = new Set(minigamesPlayed.map((item) => item === 'photo' ? 'fotografia' : item === 'wordSearch' ? 'sopa de letras' : item === 'crossWords' && 'palavras cruzadas'))

    return (
        <div className="ending">
            <h1 className='pt-6 md:pt-8'>Concluiu um dia de aventura {country === 'Grécia' || country === 'China' ? 'na' : 'no'} {country}!</h1>
            <MatildeBalloon>
                <h3>Boa! Conseguimos completar uma viagem!</h3>
                <p>Mas que viagem fantástica! Adorei, ver as diferentes paisagens e explorar a cultura, obrigado por me acompanhar nesta aventura, espero que não seja a última vez!</p>
            </MatildeBalloon>

            <h2 className='w-full'>Neste {chapterNumber}º capítulo:</h2>
            <div className='grid w-full grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 justify-center pb-12'>
                <div>
                    <h5 className='pb-2'>Rescaldo do capítulo</h5>
                    <ul>
                        <li className='mb-2'>{endingType ?
                            <span>Conseguiu conquistar o desfecho <b>bom</b>.</span> :
                            <span>Conquistou um desfecho <b>menos bom</b> do capítulo.</span>
                        }
                        </li>
                        <li className='mb-2'>Jogou minijogos como: {[...filterMinigamesPlayed].map((item, index) =>
                            minigamesPlayed.length === 1 ? <span key={index}><b>{item}</b></span> :
                                minigamesPlayed.length - 1 === index ? <span key={index}>e <b>{item}</b></span> :
                                    <span key={index}><b>{item}</b>, </span>
                        )}
                        </li>
                        <li className='mb-2'>Recebeu <b>{exp} pontos de experiência</b>.</li>
                    </ul>
                </div>
                <div>
                    <h5 className='pb-2'>Itens encontrados</h5>
                    {items ?
                        <div>
                            <p className='mb-4'>Conquistou os seguintes itens na sua aventura com a Matilde:</p>
                            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 sm:gap-8'>
                                {items.map((item, index) => (
                                    <Button
                                        key={index}
                                        onClick={() => setState({ open: !open, item: item })}
                                        className="p-4 overflow-hidden flex flex-col flex-wrap image-button usable h-full"
                                    >
                                        <img
                                            className='object-contain h-40 md:h-32 pb-2'
                                            alt={item.name}
                                            title={item.name} src={require(`../../assets/img/items/${item.img}.png`)}
                                        />
                                        <h3 className='pb-2'>{item.name}</h3>
                                    </Button>
                                ))}
                            </div>
                        </div>
                        :
                        <div>
                            <p>Infelizmente, não conquistou qualquer tipo de itens. <Emoji symbol='😢' label='triste' /></p>
                        </div>
                    }
                </div>
            </div>



            <div>
                <h3 className='pb-2'>As suas escolhas</h3>
                <p className='pb-4'>Durante este capítulo deparou-se com as seguintes situações de escolha:</p>
                <div className='grid grid-cols-1 lg:grid-col-2 gap-8 mb-8'>
                    {choicesMadeName.map((item, index) => {
                        let pieContent = _getChoicePercentage(narrativeChoices[chapter][item])
                        let individualPercentage = _getSimplePercentage(narrativeChoices[chapter][item], choicesMade[index])

                        return (
                            <div key={index}>
                                <div>
                                    <h5>{item}</h5>
                                    <p>Da mesma forma que escolheu a opção - <span className='font-bold'>{choicesMade[index]}</span> - outras pessoas que jogaram esta narrativa também a escolheram, sendo esta resposta ter sido escolhida <span className='font-bold'>{individualPercentage}% das vezes</span> nesta escolha.</p>
                                </div>
                                <div>
                                    <MyResponsivePie content={pieContent} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className='flex justify-end mb-10'>
                <Link to='/dashboard'>
                    <Button className='mr-0' onClick={() => dispatch(gameActions.quitGame())}>Voltar à página inicial</Button>
                </Link>
            </div>

            {item &&
                <Modal
                    isOpen={open}
                    contentLabel="Modal de item individual"
                    className='modal'
                    ariaHideApp={false}
                    closeTimeoutMS={300}
                    shouldCloseOnOverlayClick={true}
                    onAfterClose={() => setState({ ...state, item: null })}
                    onRequestClose={() => setTimeout(() => {
                        setState({ ...state, open: !open })
                    }, 300)}
                >
                    <div className='modal-guts'>
                        <h2 className='w-full'>{item?.name}</h2>
                        <div className='grid grid-cols-1 lg:grid-cols-2'>
                            <img
                                className='object-contain h-48 w-full'
                                alt={item?.name}
                                title={item?.name}
                                src={require(`../../assets/img/items/${item?.img}.png`)}
                            />
                            <div>
                                <p className='pb-2'><b>Descrição:</b> {item?.description}</p>
                            </div>
                        </div>
                        <div className='pt-5 flex w-full justify-end'>
                            <Button
                                className='mr-0'
                                onClick={() => setTimeout(() => {
                                    setState({ ...state, open: !open })
                                }, 300)}
                            >
                                Fechar
                            </Button>
                        </div>
                    </div>
                </Modal>
            }

        </div>
    )
}

export default NarrativeEndScreen
